export const PasswordGeneratorPageMetaData = {
  title: 'Password Generator',
  description:
    'Generate a strong password using our online password generator. Our password generator will create a random password for you that is strong and secure.',
  image: '%PUBLIC_URL%/android-icon-192x192.png',
  url: 'https://unitconversion.page/password',
  type: 'website',
}
